import styled from 'styled-components'

export const customModalStyles = {
  content: {
    top: 'auto',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0',
    display: 'flex',

  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: '10',
  },
}

export const CloseModalButton = styled.button`
    background: none!important;
    font-size: 18px;
    border: none;
    cursor: pointer;
    padding: 0;
    color: #0071ce;
    align-self: center;
  `

export const CloseHeaderTitle = styled.div`
    column-gap: 10px;
    display: flex;
    color:#0071ce;
    font-weight: bold;
    padding: 15px;
    justify-content: space-between;
  `
